var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitEuMph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_eu_x5F_mph_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_eu_x5F_mph"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 48,
    cy: 48,
    r: 46
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,14c18.778,0,34,15.222,34,34S66.778,82,48,82S14,66.778,14,48S29.222,14,48,14 M48,4 C23.738,4,4,23.738,4,48s19.738,44,44,44s44-19.738,44-44S72.262,4,48,4L48,4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.234,75.256L35.65,66h1.846l2.379,6.408L42.215,66h1.807l0.468,9.256h-1.547l-0.312-6.279l-2.275,6.279H39.29 l-2.327-6.318l-0.26,6.318H35.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.128,66h3.406c0.511,0,0.949,0.052,1.312,0.156c0.364,0.104,0.663,0.271,0.897,0.5c0.234,0.23,0.405,0.531,0.514,0.904 c0.108,0.372,0.162,0.832,0.162,1.377c0,0.581-0.061,1.062-0.182,1.443c-0.122,0.381-0.302,0.688-0.54,0.916 c-0.238,0.23-0.539,0.393-0.903,0.488s-0.789,0.143-1.274,0.143h-1.794v3.328h-1.599V66z M47.727,67.456v3.12h1.625 c0.277,0,0.509-0.02,0.695-0.059c0.187-0.039,0.334-0.117,0.442-0.234s0.187-0.279,0.234-0.487s0.071-0.477,0.071-0.806 c0-0.312-0.023-0.568-0.071-0.768s-0.128-0.355-0.24-0.468c-0.113-0.112-0.263-0.19-0.448-0.233 c-0.187-0.044-0.415-0.065-0.683-0.065H47.727z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.72,66h1.6v3.9h3.627V66h1.611v9.256h-1.611v-3.991h-3.627v3.991h-1.6V66z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitEuMph);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_eu_mph.7ea957f861ba74122255314bff4146e4.svg";
export { ForwardRef as ReactComponent };